import React, { useEffect } from "react";
import { connect } from "react-redux";

import { setDisplayModal } from "../actions/modal";

import { setCurrentPage } from "../actions/page";

import kaedco from "../assets/images/Kaduna.png";
import kedco from "../assets/images/Kano.png";
import ikedc from "../assets/icons/ikedc.svg";
import eedc from "../assets/icons/eedc.svg";
import phed from "../assets/icons/phdc.svg";
import aedc from "../assets/icons/aedc.svg";
import ekedc from "../assets/icons/ekedc.svg";
import ibedc from "../assets/images/ibedc.png";
import jed from "../assets/images/jed.jpg";
import aba from "../assets/images/ABA.jpg";
import yedc from "../assets/images/YEDC.jpg";
import bedc from "../assets/images/BEDC.png";

import gotv from "../assets/icons/gotv.svg";
import dstv from "../assets/icons/dstv.svg";
import startimes from "../assets/icons/startimes.svg";
import showmax from '../assets/icons/showmax-Icon.png'

import styles from "./BillPayment.module.scss";

export const BillPayment = ({ changeCurrentPage, displayModal }) => {
  useEffect(() => {
    changeCurrentPage({
      heading: "Bill Payment",
      search: true,
    });
  }, [changeCurrentPage]);

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={`${styles.card} ${styles.cardElectricity}`}>
          <h3 className={styles.sectionHeading}>Electricity</h3>
          <div className={styles.services}>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "aedc",
                });
              }}
            >
              <img className={styles.serviceLogo} src={aedc} alt="" />
              <p className={styles.serviceText}>AEDC</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "aba",
                });
              }}
            >
              <img className={styles.serviceLogo} src={aba} alt="" />
              <p className={styles.serviceText}>ABA</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "bedc",
                });
              }}
            >
              <img className={styles.serviceLogo} src={bedc} alt="" />
              <p className={styles.serviceText}>BEDC</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "eedc",
                });
              }}
            >
              <img className={styles.serviceLogo} src={eedc} alt="" />
              <p className={styles.serviceText}>EEDC</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "ekedc",
                });
              }}
            >
              <img className={styles.serviceLogo} src={ekedc} alt="" />
              <p className={styles.serviceText}>EKEDC</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "ibedc",
                });
              }}
            >
              <img className={styles.serviceLogo} src={ibedc} alt="" />
              <p className={styles.serviceText}>IBEDC</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "ikedc",
                });
              }}
            >
              <img className={styles.serviceLogo} src={ikedc} alt="" />
              <p className={styles.serviceText}>IKEDC</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "jed",
                });
              }}
            >
              <img className={styles.serviceLogo} src={jed} alt="" />
              <p className={styles.serviceText}>JED</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "kaedco",
                });
              }}
            >
              <img className={styles.serviceLogo} src={kaedco} alt="" />
              <p className={styles.serviceText}>KAEDCO</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "kedco",
                });
              }}
            >
              <img className={styles.serviceLogo} src={kedco} alt="" />
              <p className={styles.serviceText}>KEDCO</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "energy",
                  service: "phed",
                });
              }}
            >
              <img className={styles.serviceLogo} src={phed} alt="" />
              <p className={styles.serviceText}>PHED</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.card}>
          <h3 className={styles.sectionHeading}>Cable TV</h3>
          <div className={styles.services}>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "cableRecharge",
                  service: "dstv",
                });
              }}
            >
              <img className={styles.serviceLogo} src={dstv} alt="" />
              <p className={styles.serviceText}>DSTV</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "cableRecharge",
                  service: "gotv",
                });
              }}
            >
              <img className={styles.serviceLogo} src={gotv} alt="" />
              <p className={styles.serviceText}>GOTV</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "cableRecharge",
                  service: "startimes",
                });
              }}
            >
              <img className={styles.serviceLogo} src={startimes} alt="" />
              <p className={styles.serviceText}>Startimes</p>
            </div>
            <div
              className={styles.service}
              onClick={() => {
                displayModal({
                  overlay: true,
                  modal: "cableRecharge",
                  service: "showmax",
                });
              }}
            >
              <img className={styles.serviceLogo} src={showmax} alt="" />
              <p className={styles.serviceText}>Showmax</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCurrentPage: (payload) => dispatch(setCurrentPage(payload)),
    displayModal: (payload) => dispatch(setDisplayModal(payload)),
  };
};

export default connect(undefined, mapDispatchToProps)(BillPayment);
